// extracted by mini-css-extract-plugin
export default {"internalHeader":"styles_internalHeader__-j+9Q","alert":"styles_alert__RDh2N","link":"styles_link__Ihb8i","profile":"styles_profile__04pRj","active":"styles_active__-B1mY"};